import React from 'react';
import PropTypes from 'prop-types';

/**
 * Validation Alert component
 * @module
 * @param {string} dataInvalid - Are data invalid?
 */

const ValidationAlert = (props) => {
  const fieldsText = props.invalidFields?.length > 0 ? `Skontrolujte nasledujúce položky: ${props.invalidFields}` : "";
  return (
    <div className={"grid-validation-alert " + (props.dataInvalid ? '' : 'd-none')} >
      <p className="mb-0">{`Zadané údaje nie sú validné! ${fieldsText}`}</p>
    </div>
  )
}

ValidationAlert.propTypes = {
  dataInvalid: PropTypes.bool,
  invalidFields: PropTypes.array
}

export default ValidationAlert;